import React, { FC, useCallback, useState } from 'react';
import Button from '@mui/material/Button';
import { makeStyles } from '@mui/styles';
import { Dialog, DialogContent, DialogTitle } from '@mui/material';
import { useExceptionWords } from '../../../hooks/entityHooks';
import { IExceptionWord } from '../../../types/exceptionWord';
import classes from '../ExceptionWordDialog/ExceptionWordDialog.module.scss';
import { ReactComponent as Close } from '../../../assets/images/close.svg';
import { ReactComponent as FillClose } from '../../../assets/images/fillClose.svg';

type Props = {
  word: IExceptionWord;
  fetchData: () => void;
};

const useStyles = makeStyles({
  root: {
    background: '#FF7221 !important',
    borderRadius: '0 !important',
    width: 160,
    color: '#FFFFFF !important',
    textTransform: 'none',
    fontWeight: '550 !important',
    // color: '#FFFFFF',
    '&:hover, &:focus': {
      background: '#DE6109',
    },
    fontFamily: 'HelveticaNeueCyr',
    // boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
    height: 38,
    fontSize: 14,
    padding: '0 30px',
  },
  restore: {
    textTransform: 'none',
    background: 'white !important',
    width: 160,
    height: 38,
    fontSize: 14,
    fontFamily: 'HelveticaNeueCyr',
    color: '#FF7221 !important',
    border: '1px solid #FF7221 !important',
    borderRadius: '0 !important',
    fontWeight: '550 !important',
    marginRight: '24px !important',
  },
});

export const DeleteExceptionWordDialog: FC<Props> = ({ word, fetchData }) => {
  const { deleteEntity } = useExceptionWords();
  const [open, setOpen] = useState<boolean>(false);
  const [focus, setFocus] = useState<boolean>(false);

  const style = useStyles();

  const handleOpen = () => {
    setOpen((p) => !p);
  };

  const handleSubmit = useCallback(() => {
    deleteEntity(word.id).then(() => {
      setOpen(false);
      fetchData();
    });
  }, [word]);

  return (
    <>
      <Button className={style.root} onClick={handleOpen}>
        Удалить
      </Button>

      <Dialog open={open} onClose={handleOpen} fullWidth maxWidth="sm">
        <DialogTitle>
          <div className={classes.form__dialogTitle}>
            <span>Удаление</span>
            {/* eslint-disable-next-line jsx-a11y/mouse-events-have-key-events */}
            <div
              className={classes.close}
              onMouseOver={() => setFocus(true)}
              onMouseOut={() => setFocus(false)}
              onClick={() => setOpen(false)}
            >
              {focus ? <FillClose /> : <Close />}
            </div>
          </div>
        </DialogTitle>
        <DialogContent>
          <div>
            <div className={classes.dialogContent}>
              <p>Вы точно хотите удалить слово &quot;{word.word}&quot;?</p>
            </div>
          </div>
        </DialogContent>
        <div className={classes.form__row__button}>
          <Button className={style.restore} type="button" onClick={handleOpen}>
            Отмена
          </Button>
          <Button className={style.root} color="primary" onClick={handleSubmit}>
            Удалить
          </Button>
        </div>
      </Dialog>
    </>
  );
};
